module.exports = __webpack_public_path__ + "img/pdf.498c117e.png";